(() => {
    jQuery(document).ready(function ($) {

        // 
        // Trigger effects on home page
        // 
        // On page load remove 'paint-effect' class on that element ONLY
        $('.practices-wrap .container .animations-parent.animated').removeClass('paint-effect');
        $('.slide-article .container .animations-parent.animated').removeClass('paint-effect');

        const mediaArticles = '.media-articles-gird .container .row';
        const ourStory = '.our-story .container';
        const practicesList = '.practices-list';
        const stayUpdate = '.stay-updated .container .row';
        const historyBanner = '.our-history-banner';
        const slideArticle = '.slide-article';
        const membersSearch = '.members-search-results .container';

        $(document).scroll(function () {
            const yPos = $(window).scrollTop();
            console.log('scroll');

            if (checkElement(mediaArticles) && yPos > getYPosition(mediaArticles)) {
                $(mediaArticles + ' .animations-parent .animated').addClass('paint-effect');
            }

            if (checkElement(ourStory) && yPos > getYPosition(ourStory)) {
                $('.our-story .animations-parent .animated').addClass('expose-effect');
            }

            if (checkElement(practicesList) && yPos > getYPosition(practicesList) + 100) {
                $('.practices-list .container .part-section-title.animated').addClass('paint-effect');
                $('.practices-list .container .row .animations-parent .animated').addClass('expose-effect');
            }

            if (checkElement(stayUpdate) && yPos > getYPosition(stayUpdate)) {
                $(stayUpdate + ' .animations-parent .animated').addClass('paint-effect');
            }

            if (checkElement(historyBanner) && yPos > getYPosition(historyBanner) + 100) {
                $(historyBanner + ' .container .row .content .animations-parent .animated').addClass('expose-effect');
            }

            // Outside homepage

            if (checkElement(membersSearch) && yPos > getYPosition(membersSearch)) {
                console.log('paint effect');
                $(membersSearch + ' .animations-parent .animated').addClass('paint-effect');
            }

            if (checkElement(slideArticle) && yPos > getYPosition(slideArticle) + 100) {
                $(slideArticle + ' .container .part-section-title.animated').addClass('paint-effect');
                $(slideArticle + ' .container .row .animations-parent .animated').addClass('paint-effect');
            }
        });

    });

    function getYPosition(element) {
        return $(element).position().top - $(window).height() + 300;
    }

    function checkElement(elem) {
        return $(elem).length > 0;
    }

    function addAnimation(element, theClass) {
        $(element).addClass(theClass);
    }

})();